module.exports = __webpack_public_path__ + "img/sports.69a03e4f.jpg";